<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">
    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
    
        <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
           
            <div class="relative">
                <input type="text" [(ngModel)]="search" (input)="onSearchInput()" placeholder="Search.." class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>

             <div>
                <select (change)="onSelectStatus()" [(ngModel)]="status" id="inputStatus" class="min-w-40">
                    <!-- <option value="Status">Select Status</option> -->
                    <option [ngValue]="true">Active</option>
                    <option [ngValue]="false">Inactive</option>
                </select>
            </div>
        </div>
    
        <div *ngIf="standingorderMembers && standingorderMembers.length">
            <h1 class="text-xs text-nowrap text-left">Showing {{(numberOfRecords * currentPage) - (standingorderMembers != numberOfRecords? (numberOfRecords
                -standingorderMembers.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
    
        <div class="">
            <button routerLink="new" *ngIf="permissionService.hasPermission([userPermission.MANAGE_STANDING_ORDER])"
                class="btn btn-secondary">
                Create
            </button>
        </div>
    
    </div>

    <div
        class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead class="bg-zinc-950/5 dark:bg-white/5">
                                <tr>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Action
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Name</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Reference ID</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Space Type</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Recurring Days</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Start Date</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        End Date</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                                    *ngFor="let trip of standingorderMembers | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i=index">
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{i+1}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div class="flex gap-2">
                                            <button [appToolTip]="'Detail'"  (click)="opendetailModal(trip)">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                </svg>
                                            </button>
                                            <button class="border-l border-zinc-300 px-2">
                                                <a [appToolTip]="'Edit'" routerLink="/trips/{{trip.id}}/standing-order/edit">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                        class="size-5 text-zinc-500 dark:text-zinc-400">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                                    </svg> 
                                                </a>
                                            </button>
                                        </div>
                                    </td>
                                    <!-- <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                                        {{member.requesterName}}
                                    </td> -->
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span *ngIf="trip?.member else elseBlock">
                                            {{(trip?.member.displayName) | titlecase}}
                                        </span>
                                    </td>

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                         {{trip.reference || 'N/A'}}-{{trip.suffix}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span *ngIf="prespacetypes && prespacetypes[trip.spaceType]">
                                            {{((prespacetypes[trip.spaceType].title) | uppercase) || 'N/A'}}
                                        </span>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <ng-container *ngFor="let day of trip.repeat">
                                            <span class="badge-primary mx-1">{{(day | titlecase) || 'N/A' }}</span>
                                        </ng-container>
                                    </td>

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{ (trip.startDate | date : 'MM/DD/YYYY') || 'N/A' }}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{ (trip.endDate | date : 'MM/DD/YYYY') || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span [ngClass]="trip.isActive ? 'badge-success':'badge-danger'">{{trip.isActive
                                            ? 'Active' :
                                            'Inactive'}}</span>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                         <ng-template #elseBlock>N/A</ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>
</section>

<app-standingorder-detail-modal *ngIf="trip" [trip]="trip" (closeModal)="trip = null"></app-standingorder-detail-modal>